import React from "react";
import { gettext } from "../../adapter";
import Select from "react-select";
import { useDispatch } from "react-redux";
import weatherRegionsActions from "./../../actions/weatherRegionsActions";

const WeatherForecastRegions = ({ apiUrl, regions, selectedRegion }) => {
  const dispatch = useDispatch();
  var list;
  if (regions.length < 5) {
    regions = regions.map(function (region) {
      var handleClick = function () {
        dispatch(weatherRegionsActions.selectFetchRegion(apiUrl, region.id));
      };

      if (region.id === selectedRegion.id) {
        return (
          <li className="is-selected" key={region.id}>
            {/* eslint-disable-next-line */}
            <a onClick={handleClick}>{region.name}</a>
          </li>
        );
      } else {
        return (
          <li key={region.id}>
            {/* eslint-disable-next-line */}
            <a onClick={handleClick}>{region.name}</a>
          </li>
        );
      }
    });
    list = <ul>{regions}</ul>;
  } else {
    regions = regions.map((region) => {
      return {
        value: region.id,
        label: region.name,
      };
    });

    list = (
      <Select
        defaultValue={{ value: selectedRegion.id, label: selectedRegion.name }}
        options={regions}
        className="react-select-container"
        classNamePrefix="react-select"
        noOptionsMessage={(input) => gettext("No results for") + ' "' + input.inputValue + '"'}
        onChange={(selected) => {
          dispatch(weatherRegionsActions.selectFetchRegion(apiUrl, selected.value));
        }}
      />
    );
  }

  return <div className="tabs l-full text-center">{list}</div>;
};

export default WeatherForecastRegions;
